import type { BadgeProps } from '@/libs/serenity-ui';

const DEFAULT_BADGE_STYLES: BadgeProps = {
  size: 20,
  isPastel: true,
};

export const theme = {
  badge: {
    Draft: Object.assign<BadgeProps, BadgeProps>({ color: 'blueLight' }, DEFAULT_BADGE_STYLES),
    'In review': Object.assign<BadgeProps, BadgeProps>({ color: 'blueDark' }, DEFAULT_BADGE_STYLES),
    Processing: Object.assign<BadgeProps, BadgeProps>({ color: 'yellow' }, DEFAULT_BADGE_STYLES),
    Active: Object.assign<BadgeProps, BadgeProps>({ color: 'green' }, DEFAULT_BADGE_STYLES),
    Paused: Object.assign<BadgeProps, BadgeProps>({ color: 'orange' }, DEFAULT_BADGE_STYLES),
    Ended: Object.assign<BadgeProps, BadgeProps>({ color: 'greyLight' }, DEFAULT_BADGE_STYLES),
    Completed: Object.assign<BadgeProps, BadgeProps>({ color: 'violet' }, DEFAULT_BADGE_STYLES),
    Declined: Object.assign<BadgeProps, BadgeProps>({ color: 'red' }, DEFAULT_BADGE_STYLES),
    Approved: Object.assign<BadgeProps, BadgeProps>({ color: 'green' }, DEFAULT_BADGE_STYLES),
    Cancelled: Object.assign<BadgeProps, BadgeProps>({ color: 'red' }, DEFAULT_BADGE_STYLES),
    Inactive: Object.assign<BadgeProps, BadgeProps>({ color: 'greyLight' }, DEFAULT_BADGE_STYLES),
    Negotiating: Object.assign<BadgeProps, BadgeProps>({ color: 'yellow' }, DEFAULT_BADGE_STYLES),
    Confirmed: Object.assign<BadgeProps, BadgeProps>({ color: 'blueLight' }, DEFAULT_BADGE_STYLES),
    'Ready for launch': Object.assign<BadgeProps, BadgeProps>({ color: 'blueDark' }, DEFAULT_BADGE_STYLES),
    Live: Object.assign<BadgeProps, BadgeProps>({ color: 'green' }, DEFAULT_BADGE_STYLES),
    Lost: Object.assign<BadgeProps, BadgeProps>({ color: 'orange' }, DEFAULT_BADGE_STYLES),
    NPI: Object.assign<BadgeProps, BadgeProps>({ color: 'orange' }, DEFAULT_BADGE_STYLES),
    Geo: Object.assign<BadgeProps, BadgeProps>({ color: 'green' }, DEFAULT_BADGE_STYLES),
    RoN: Object.assign<BadgeProps, BadgeProps>({ color: 'violet' }, DEFAULT_BADGE_STYLES),
    Specialty: Object.assign<BadgeProps, BadgeProps>({ color: 'blueDark' }, DEFAULT_BADGE_STYLES),
    'Specialty-auth': Object.assign<BadgeProps, BadgeProps>({ color: 'blueDark' }, DEFAULT_BADGE_STYLES),
    Evenly: Object.assign<BadgeProps, BadgeProps>({ color: 'blueLight' }, DEFAULT_BADGE_STYLES),
    'Front-loaded': Object.assign<BadgeProps, BadgeProps>({ color: 'violet' }, DEFAULT_BADGE_STYLES),
    'Custom monthly': Object.assign<BadgeProps, BadgeProps>({ color: 'orange' }, DEFAULT_BADGE_STYLES),
  } as Record<string, BadgeProps>,
  dateFormat: {
    full: { month: 'short', day: 'numeric', year: 'numeric' } satisfies Intl.DateTimeFormatOptions,
    short: { month: 'short', year: 'numeric' } satisfies Intl.DateTimeFormatOptions,
    withTime: { hour: 'numeric', minute: '2-digit', month: 'short', day: 'numeric', year: 'numeric' } satisfies Intl.DateTimeFormatOptions,
  },
};
